import { InlineStack, Spinner } from "@shopify/polaris";

export const SpinnerCentered = () => (
  <InlineStack align="center">
    <Spinner />
  </InlineStack>
);
